export default "__VITE_ASSET__e4c8400e__"